import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Toast } from 'primereact/toast';
import { ConfigContext } from '../../Context/ConfigContext';
import { Checkbox } from "primereact/checkbox";
import { Skeleton } from 'primereact/skeleton';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useNavigate, useParams } from 'react-router-dom';
import { motion, AnimatePresence } from "framer-motion";
import StoreSelect from '../../Components/Store';
import StockTransferPrint from '../PrintHelper/StockTransferPrint';

const StockTransfer = () => {
    const toast = useRef(null);
    const { apiUrl, apiHeadersJson, baseurl, store_id, auth_routes } = useContext(ConfigContext);
    const [products, setProducts] = useState([]);
    const [isPrint, setisPrint] = useState(false);
    const [lastAddedIndex, setLastAddedIndex] = useState(null);
    const [focusedIndex, setFocusedIndex] = useState(null);
    const [Categories, setCategories] = useState([]);
    const [transferItems, setTransferItems] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [listLoading, setListLoading] = useState(true);
    const [addLoading, setAddLoading] = useState(false);
    const [transferLoading, setTransferLoading] = useState(false);
    const headers = apiHeadersJson;
    const [Category, setCategory] = useState(null);
    const { inv_transfer_id, purchase_id } = useParams();
    const inputRefs = useRef({});
    const navigate = useNavigate();
    const [toStoreId, setToStoreId] = useState('');

    /// print states
    const [dataLoading, setDataLoading] = useState(false);
    const [invoiceData, setInvoiceData] = useState({});
    const [printProducts, setPrintProducts] = useState([]);
    const [user, setUser] = useState({});
    const [isReadyToPrint, setIsReadyToPrint] = useState(false);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
            }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1
        }
    };

    const handleKeyboardInput = (num) => {
        if (focusedIndex !== null) {
            const item = transferItems[focusedIndex];
            if (item) {
                const currentQty = item.transfer_qty ?? '';
                const newQty = parseInt(`${currentQty}${num}`, 10);
                handleInputChange(focusedIndex, 'transfer_qty', newQty);
            }
        }
    };

    const handleClearInput = () => {
        if (focusedIndex !== null) {
            handleInputChange(focusedIndex, 'transfer_qty', 0);
        }
    };

    const handleBackspaceInput = () => {
        if (focusedIndex !== null) {
            const item = transferItems[focusedIndex];
            if (item) {
                const currentQty = (item.transfer_qty ?? '0').toString();
                const newQty = currentQty.slice(0, -1) || '0';
                handleInputChange(focusedIndex, 'transfer_qty', parseInt(newQty, 10));
            }
        }
    };

    const filteredProducts = Category
        ? products.filter((product) =>
            (product.category_id === Category.category_id) &&
            (product.product_name.toLowerCase().includes(searchTerm.toLowerCase()))
        )
        : products.filter((product) =>
            product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
        );

    const handleAddProductByName = async (product_name) => {
        if (!toStoreId) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Select To Store First',
                life: 1000,
            });
            if (navigator.vibrate) navigator.vibrate(500);
            return;
        }

        setAddLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetProductInfoByName`, {
                params: { product_name, from_store_id: store_id, to_store_id: toStoreId },
                headers,
            });

            const audio = new Audio(`https://www.mamtafood.com/assets/audio/coin.mp3`);
            audio.play();
            setAddLoading(false);

            const { success, from_result, to_result, message } = response.data;

            if (success) {
                const fromProduct = from_result[0];
                const toProduct = to_result[0];

                if (!fromProduct) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Product not found in source store',
                        life: 1000,
                    });
                    return;
                }

                const transferItem = {
                    // From product info
                    from_product_id: fromProduct.product_id,
                    from_store_id: fromProduct.store_id,
                    from_category_id: fromProduct.category_id,
                    from_product_name: fromProduct.product_name,
                    from_product_barcode: fromProduct.product_barcode,
                    from_product_purchase_rate: fromProduct.product_purchase_rate,
                    from_product_sale_rate: fromProduct.product_sale_rate,
                    from_product_retail_rate: fromProduct.product_retail_rate,

                    // To product info (if exists)
                    to_product_id: toProduct?.product_id || null,
                    to_store_id: toProduct?.store_id || null,
                    to_category_id: toProduct?.category_id || null,
                    to_product_name: toProduct?.product_name || fromProduct.product_name,
                    to_product_barcode: toProduct?.product_barcode || '',
                    to_product_purchase_rate: toProduct?.product_purchase_rate || fromProduct.product_purchase_rate,
                    to_product_sale_rate: toProduct?.product_sale_rate || '',
                    to_product_retail_rate: toProduct?.product_retail_rate || '',

                    // Transfer details
                    transfer_qty: 1,
                };


                const existingIndex = transferItems.findIndex(
                    item => item.from_product_id === fromProduct.product_id
                );

                if (existingIndex >= 0) {
                    // Update quantity if product already exists
                    setTransferItems(prev => prev.map((item, idx) =>
                        idx === existingIndex
                            ? { ...item, transfer_qty: item.transfer_qty + 1 }
                            : item
                    ));
                    setLastAddedIndex(existingIndex);
                } else {
                    // Add new transfer item
                    setTransferItems(prev => [...prev, transferItem]);
                    setLastAddedIndex(transferItems.length);
                }

                if (navigator.vibrate) navigator.vibrate(200);
            } else {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: message,
                    life: 1000,
                });
                if (navigator.vibrate) navigator.vibrate(500);
            }
        } catch (error) {
            console.error('Error:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Unable to fetch product info',
                life: 1000,
            });
            setAddLoading(false);
            if (navigator.vibrate) navigator.vibrate(500);
        } finally {
            setAddLoading(false);
        }
    };

    useEffect(() => {
        let barcodeBuffer = '';
        let timer;
        const handleKeyPress = (event) => {
            clearTimeout(timer);

            if (event.key === 'Enter') {
                if (barcodeBuffer) {
                    handleAddProductByName(barcodeBuffer, 'barcode');
                    barcodeBuffer = '';
                }
            } else {
                barcodeBuffer += event.key;
            }

            timer = setTimeout(() => {
                barcodeBuffer = '';
            }, 300);
        };

        window.addEventListener('keypress', handleKeyPress);

        return () => {
            window.removeEventListener('keypress', handleKeyPress);
        };
    }, [handleAddProductByName]);

    const handleRemoveItem = (index) => {
        setTransferItems(prev => prev.filter((_, idx) => idx !== index));
    };

    const handleInputChange = (index, field, value) => {
        const numericValue = Number(value);

        if (!isNaN(numericValue)) {
            setTransferItems(prev =>
                prev.map((item, idx) => (idx === index ? { ...item, [field]: numericValue } : item))
            );
        }
    };

    function generateTransferNumber() {
        if (inv_transfer_id) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: "You Cannot Update the Invoice Number", life: 1000 });
            return;
        }
        const prefix = "ST-";
        const randomNumber = Math.floor(Math.random() * 9000) + 1000;
        const transferNum = prefix + randomNumber;
        setInvoiceNumber(transferNum);
    }

    const handleResetForm = () => {
        setToStoreId('');
        setInvoiceNumber('');
        setTransferItems([]);
        if (inv_transfer_id) {
            navigate('/StockTransferReports')
        }
    };

    const handlePrint = async (id) => {
        try {
            await getPrintInfo(id);
            setIsReadyToPrint(true);
        } catch (error) {
            console.log('error', error);
            alert('error while printing');
        }
    };

    const getPrintInfo = async (id) => {
        setDataLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Reports/GetStockTransferInvoice`, { params: { inv_transfer_id: id, }, headers });
            const { success, data, prodcuts, user, message } = response.data;

            if (success) {
                setInvoiceData(data[0]);
                setPrintProducts(prodcuts);
                setUser(user[0]);
                if (prodcuts?.length === 0) {
                    alert('Sorry No Product Found Please Check The Bill');
                }
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('Error fetching invoice:', error);
            alert('error while fetching print data');
        } finally {
            setDataLoading(false);
        }
    };

    const performPrint = () => {
        const invoiceContainer = document.querySelector('.puechase-invoice-container');
        if (!invoiceContainer) {
            alert("Stock Transfer Invoice not found.");
            return;
        }

        const styles = Array.from(document.styleSheets)
            .map(sheet => {
                try {
                    return Array.from(sheet.cssRules)
                        .map(rule => rule.cssText)
                        .join('\n');
                } catch (e) {
                    return '';
                }
            })
            .join('\n');

        const htmlContent = `
        <html>
            <head><style>${styles}</style></head>
            <body>${invoiceContainer.innerHTML}</body>
        </html>
    `;

        if (window.electronAPI) {
            window.electronAPI.silentPrint(htmlContent);
        } else {
            const printWindow = window.open('', '_blank');
            printWindow.document.write(htmlContent);
            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 1000);
        }
    };

    useEffect(() => {
        if (isReadyToPrint && invoiceData && printProducts.length > 0 && user) {
            performPrint();
            setIsReadyToPrint(false);
        }
    }, [invoiceData, printProducts, user]);

    const handleSubmit = async () => {
        const body = {
            inv_transfer_id: inv_transfer_id,
            purchase_id: purchase_id,
            from_store_id: store_id,
            to_store_id: toStoreId,
            invoice_number: invoiceNumber,
            rows: transferItems,
        };

        try {
            setTransferLoading(true);
            const response = await axios.post(`${apiUrl}/Management/StockTransfer`, body, { headers });
            setTransferLoading(false);
            const { success, message, cr_inv_transfer_id, } = response.data;

            if (success) {
                if (isPrint) {
                    await handlePrint(cr_inv_transfer_id);
                }
                handleResetForm();
                fetchDropdownData();
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 1000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 1000 });
            }

        } catch (error) {
            console.log('error', error);
            setTransferLoading(false);
        }
    };

    const fetchDropdownData = async () => {
        try {
            setListLoading(true);
            const [usersRes, productRes] = await Promise.all([
                axios.get(`${apiUrl}/Masters/CategoryList`, { params: { store_id: store_id }, headers }),
                axios.get(`${apiUrl}/Masters/ProductList`, { params: { store_id: store_id }, headers }),
            ]);

            setListLoading(false);
            setCategories(usersRes.data.data || []);
            setProducts(productRes.data.data || []);
        } catch (error) {
            setListLoading(false);
            console.error('Error fetching DropdownData:', error);
        }
    };

    useEffect(() => {
        store_id && fetchDropdownData();
    }, [store_id]);

    const calculateRowTotal = (item) => {
        return item.from_product_purchase_rate * item.transfer_qty;
    };

    const calculateTotalQty = () => {
        return transferItems.reduce((acc, item) => acc + item.transfer_qty, 0);
    };

    const GetTransferDetails = async () => {
        try {
            const response = await axios.get(`${apiUrl}/Management/GetStockTransferProducts`, {
                params: { inv_transfer_id, purchase_id },
                headers,
            });

            const { success, data, rows, message } = response.data;

            if (success) {
                // 1. Group by product name instead of product_id
                const groupedByProductName = rows.reduce((acc, row) => {
                    const nameKey = row.product_name.trim();
                    if (!acc[nameKey]) {
                        acc[nameKey] = [];
                    }
                    acc[nameKey].push(row);
                    return acc;
                }, {});

                // 2. Map grouped data to transfer item structure
                const mappedItems = Object.values(groupedByProductName).map((productGroup) => {
                    const outgoingItem = productGroup.find((item) => item.stock_voucher_type === "ST");
                    const incomingItem = productGroup.find((item) => item.stock_voucher_type === "Purchase");

                    return {
                        // From Product (ST - Stock Transfer)
                        from_product_id: outgoingItem?.product_id || null,
                        from_store_id: outgoingItem?.store_id || data[0].from_store_id,
                        from_category_id: outgoingItem?.category_id || null,
                        from_product_name: outgoingItem?.product_name || productGroup[0].product_name,
                        from_product_barcode: outgoingItem?.product_barcode || '',
                        from_product_purchase_rate: outgoingItem?.stock_purchase_price || productGroup[0].stock_purchase_price,
                        from_product_sale_rate: outgoingItem?.stock_sale_price || productGroup[0].stock_sale_price,
                        from_product_retail_rate: outgoingItem?.product_retail_rate || null,
                        stock_id: outgoingItem?.stock_id || null, // 3. Always get stock_id from ST type

                        // To Product (Purchase)
                        to_product_id: incomingItem?.product_id || null,
                        to_store_id: incomingItem?.store_id || data[0].to_store_id,
                        to_category_id: incomingItem?.category_id || null,
                        to_product_name: incomingItem?.product_name || productGroup[0].product_name,
                        to_product_barcode: incomingItem?.product_barcode || '',
                        to_product_purchase_rate: incomingItem?.stock_purchase_price || productGroup[0].stock_purchase_price,
                        to_product_sale_rate: incomingItem?.stock_sale_price || productGroup[0].stock_sale_price,
                        to_product_retail_rate: incomingItem?.product_retail_rate || null,

                        // Transfer Quantity
                        transfer_qty: Math.abs(outgoingItem?.stock_out || incomingItem?.stock_in || 0),
                    };
                });

                setTransferItems(mappedItems);
                setToStoreId(data[0].to_store_id);
                setInvoiceNumber(data[0].invoice_number);
            } else {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: message,
                    life: 1000,
                });
            }
        } catch (error) {
            console.error('Error fetching transfer details:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to fetch data.',
                life: 1000,
            });
        }
    };


    useEffect(() => {
        setToStoreId('');
        setInvoiceNumber('');
        setTransferItems([]);
    }, [store_id]);

    useEffect(() => {
        if (inv_transfer_id) {
            GetTransferDetails();
        }
    }, [inv_transfer_id]);

    useEffect(() => {
        if (lastAddedIndex !== null && inputRefs.current[lastAddedIndex]) {
            inputRefs.current[lastAddedIndex].focus();
            inputRefs.current[lastAddedIndex].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    }, [lastAddedIndex]);

    return (
        <div className="container-fluid" style={{ background: 'hsl(120deg 100% 97.06%)' }}>
            <Toast ref={toast} position="top-right" />
            <motion.div
                className="row pt-3 bg-light"
                style={{ borderBottom: "1px solid #000" }}
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.1 }}
            >
                <div className="col-md-2">
                    <h6>Stock Transfer</h6>
                </div>
                <div className="col-md-2">
                    {auth_routes.includes('StockTransferInvoice') && <div className="flex align-items-center">
                        <label htmlFor="print">
                            <Checkbox checked={isPrint} id='print' className="me-2" onChange={(e) => { setisPrint(e.target.checked) }} />
                            Print
                        </label>
                    </div>}
                </div>
                <div className="col-md-1"></div>
                <div className="col-md-2">
                    <button className='btn btn-info btn-sm text-white w-100' onClick={() => window.open(`#/StockTransfer`)}>New Transfer</button>
                </div>
                <div className="col-md-4">
                    <div className="p-inputgroup flex-1">
                        <IconField iconPosition="left" className='w-100'>
                            <InputIcon className="pi pi-search"> </InputIcon>
                            <InputText placeholder="Search By Product Name..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className='w-100' style={{ height: '35px' }} />
                        </IconField>
                    </div>
                </div>
                <div className="col-md-1"></div>
            </motion.div>
            <div className="row">
                <div className="col-md-5 border border-1 bg-light d-flex flex-column" style={{ height: 'calc(100vh - 120px)' }}>
                    <motion.div
                        className="flex-grow-1"
                        style={{ overflowY: 'auto' }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.1 }}
                    >
                        <table className="table m-0 table-hover table-bordered table-striped table-sm">
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Rate</th>
                                    <th>Qty</th>
                                    <th>Total</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {transferItems.length > 0 ? (
                                <tbody>
                                    <AnimatePresence>
                                        {transferItems.map((item, index) => (
                                            <motion.tr
                                                layout
                                                key={`${item.from_product_id}-${item.to_product_id || 'new'}`}
                                                initial={{ opacity: 0, x: -20 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                exit={{ opacity: 0 }}
                                                transition={{ duration: 0.1 }}
                                                onClick={() => { setFocusedIndex(index); setLastAddedIndex(index) }}
                                                className={focusedIndex === index ? 'border border-2 border-danger table-active' : ''}
                                            >
                                                <td className="w-25">
                                                    <div>
                                                        <strong>{item.from_product_name}</strong>
                                                    </div>
                                                </td>
                                                <td>{item.from_product_purchase_rate}</td>
                                                <td style={{ width: '130px' }}>
                                                    <div className="d-flex">
                                                        <button
                                                            type="button"
                                                            disabled={item.transfer_qty <= 1}
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => handleInputChange(
                                                                index,
                                                                'transfer_qty',
                                                                item.transfer_qty - 1
                                                            )}
                                                        >
                                                            <i className="pi pi-minus"></i>
                                                        </button>
                                                        <input
                                                            type="text"
                                                            className="form-control p-1"
                                                            placeholder="Qty"
                                                            value={item.transfer_qty}
                                                            ref={el => inputRefs.current[index] = el}
                                                            onFocus={() => setFocusedIndex(index)}
                                                            onChange={(e) => handleInputChange(
                                                                index,
                                                                'transfer_qty',
                                                                Number(e.target.value)
                                                            )}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-success btn-sm"
                                                            onClick={() => handleInputChange(
                                                                index,
                                                                'transfer_qty',
                                                                item.transfer_qty + 1
                                                            )}
                                                        >
                                                            <i className="pi pi-plus"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>{calculateRowTotal(item).toFixed(2)}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleRemoveItem(index)}
                                                    >
                                                        <i className="pi pi-trash"></i>
                                                    </button>
                                                </td>
                                            </motion.tr>
                                        ))}
                                    </AnimatePresence>
                                </tbody>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td className="w-25 text-muted" colSpan={6}>
                                            Add Products to Transfer ..........!
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </motion.div>

                    <motion.div
                        className="row my-3"
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                    >
                        <div className="col-md-6">
                            <StoreSelect disabled={inv_transfer_id} setStoreId={setToStoreId} storeId={toStoreId} placeholder='Select To Store' />
                        </div>
                        <div className="col-md-6">
                            <div className="input-group">
                                <button
                                    onClick={generateTransferNumber}
                                    className="btn bg-primary d-flex align-items-center justify-content-center"
                                    style={{ width: '40px' }}
                                    type="button"
                                >
                                    <i className="pi pi-refresh"></i>
                                </button>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Invoice No"
                                    value={invoiceNumber}
                                    disabled
                                    style={{ height: '35px' }}
                                />
                            </div>
                        </div>
                    </motion.div>
                    <motion.div
                        className="row bg-danger mt-auto"
                        initial={{ scale: 0.95, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: "spring", stiffness: 100 }}
                    >
                        <div className="col-md-6">
                            <div className="row" style={{ marginTop: '13px' }}>
                                <div className="col-md-12">
                                    <small className='small text-light '>Total Items : <strong>{transferItems.length}</strong></small>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <small className='small text-light '>Total Qty : <strong>{calculateTotalQty()}</strong></small>
                                </div>
                            </div>
                            <div className="row d-flex justify-content-center align-items-center" style={{ marginTop: '17px', }}>
                                <button
                                    className='btn btn-success btn-sm ms-1 w-75'
                                    onClick={handleSubmit}
                                    disabled={transferLoading || !toStoreId || !invoiceNumber || transferItems.length === 0 || !store_id}
                                >
                                    {dataLoading ? 'Preparing Print....!' : transferLoading ? "Processing..." : inv_transfer_id ? "Update Transfer" : "Transfer Stock"}
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row gx-7 gy-7">
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((num, i) => (
                                    <motion.div
                                        key={num}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.1, delay: i * 0.09 }}
                                        className="col-4"
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-outline-light w-100 btn-sm"
                                            key={num}
                                            onClick={() => handleKeyboardInput(num)}
                                        >
                                            {num}
                                        </button>
                                    </motion.div>
                                ))}
                                <div className="col-4">
                                    <button
                                        type="button"
                                        className="btn btn-outline-warning w-100 btn-sm"
                                        onClick={handleClearInput}
                                    >
                                        Clear
                                    </button>
                                </div>
                                <div className="col-4">
                                    <button
                                        type="button"
                                        className="btn btn-danger w-100 btn-sm"
                                        onClick={handleBackspaceInput}
                                    >
                                        <i className='pi pi-delete-left'></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>

                <div className="col-md-2 d-flex flex-column">
                    {listLoading ? (
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                            <Skeleton width="100%" height="calc(100vh - 120px)" className="rounded-0" />
                        </motion.div>
                    ) : (
                        <motion.div
                            initial={{ x: -20, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.2 }}
                            className="flex-grow-1 d-flex flex-column"
                        >
                            <div
                                style={{
                                    maxHeight: "calc(100vh - 120px)",
                                    overflowY: "auto",
                                    padding: "5px",
                                    background: '#fff',
                                    scrollbarWidth: "thin",
                                }}
                                className="d-flex flex-column gap-2"
                            >
                                {Categories.map((category, index) => (
                                    <motion.div
                                        key={index}
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.1, delay: Number(`0.${index}`) }}
                                    >
                                        <div
                                            onClick={() => setCategory(Category === category ? "" : category)}
                                            style={{
                                                padding: "12px 16px",
                                                cursor: "pointer",
                                                backgroundColor: Category === category ? "#ffffff" : "rgb(220 53 69)",
                                                color: Category === category ? "rgb(220 53 69)" : "#ffffff",
                                                boxShadow: Category === category
                                                    ? "0 2px 8px rgba(255, 255, 255, 0.3)"
                                                    : "0 1px 3px rgba(0, 0, 0, 0.2)",
                                                border: Category === category
                                                    ? "2px solid rgb(220 53 69)"
                                                    : "1px solid rgb(220 53 69)",
                                                transition: "all 0.2s ease-out",
                                            }}
                                            className="d-flex align-items-center gap-3"
                                        >
                                            {category.icon && (
                                                <div
                                                    style={{
                                                        width: "28px",
                                                        height: "28px",
                                                        backgroundColor: Category === category
                                                            ? "#d32f2f"
                                                            : "#ffffff",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: Category === category ? "#ffffff" : "rgb(220 53 69)",
                                                    }}
                                                >
                                                    {category.icon}
                                                </div>
                                            )}
                                            <span
                                                style={{
                                                    fontWeight: Category === category ? "700" : "600",
                                                    fontSize: "0.9rem",
                                                    letterSpacing: "0.3px"
                                                }}
                                            >
                                                {category.name}
                                            </span>
                                            {Category === category && (
                                                <div className="ms-auto">
                                                    <i className="pi pi-check" style={{ color: "#d32f2f", fontWeight: "bold" }}></i>
                                                </div>
                                            )}
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        </motion.div>
                    )}
                </div>

                <div className="col-md-5 p-0">
                    <div className="h-100 rounded-0" style={{
                        background: 'linear-gradient(90deg, #e4e8eb 0%,rgb(250, 250, 250) 100%)',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%'
                    }}>
                        <div
                            style={{
                                flex: 1,
                                overflowY: 'auto',
                                padding: '0px 12px',
                                maxHeight: "calc(100vh - 120px)",
                                scrollbarWidth: 'thin',
                                scrollbarColor: '#c1c1c1 #f1f1f1',
                            }}
                        >
                            {listLoading ? (
                                <motion.div
                                    className="row g-3"
                                    variants={containerVariants}
                                    initial="hidden"
                                    animate="visible"
                                >
                                    {[...Array(12)].map((_, i) => (
                                        <motion.div
                                            className="col-4 col-md-4"
                                            key={i}
                                            variants={itemVariants}
                                        >
                                            <div className="card h-100 border-0 shadow-sm overflow-hidden">
                                                <h6 className="card-title text-truncate"><Skeleton width='100%' height='18vh'></Skeleton></h6>
                                                <div className="card-body">
                                                    <Skeleton width="100%" height="20px" className="mb-2" />
                                                    <div className="d-flex justify-content-between">
                                                        <Skeleton width="60px" height="16px" />
                                                        <Skeleton width="40px" height="16px" />
                                                    </div>
                                                </div>
                                            </div>
                                        </motion.div>
                                    ))}
                                </motion.div>
                            ) : (
                                <motion.div
                                    className="row row-cols-3 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 g-2"
                                    variants={containerVariants}
                                    initial="hidden"
                                    animate="visible"
                                >
                                    {filteredProducts.length > 0 ? (
                                        filteredProducts.map((product, i) => (
                                            <motion.div
                                                layout
                                                key={i}
                                                className="col-4 col-md-4"
                                                initial={{ opacity: 0, scale: 0.95 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{ duration: 0.1 }}
                                                whileHover={{ scale: 1.02 }}
                                                whileTap={{ scale: 0.98 }}
                                            >
                                                <div
                                                    className={`card h-100 border-0 shadow-sm overflow-hidden position-relative ${product.product_min_alert > product.total_remaining ? 'blink-animation' : ''
                                                        } ${addLoading ? 'pe-none' : ''}`}
                                                    onClick={() => {
                                                        // Prevent clicks while loading
                                                        if (addLoading) return;

                                                        // Check stock availability
                                                        if (Number(product?.total_remaining) === 0 || !product?.total_remaining) {
                                                            toast.current.show({
                                                                severity: 'error',
                                                                summary: 'Error',
                                                                detail: 'This product is out of stock and cannot be added.',
                                                                life: 1000,
                                                            });
                                                            return;
                                                        }

                                                        // Only proceed if product is available and not loading
                                                        handleAddProductByName(product.product_name);
                                                    }}
                                                    style={{
                                                        cursor: addLoading ? 'wait' : 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        opacity: addLoading ? 0.7 : 1
                                                    }}
                                                >
                                                    <div className="ratio ratio-1x1 bg-light">
                                                        <img
                                                            src={product.product_image_url}
                                                            className="card-img-top p-2 object-fit-contain"
                                                            alt={product.product_name}
                                                            loading='lazy'
                                                            style={{ transition: 'transform 0.3s ease' }}
                                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                        />
                                                    </div>
                                                    <div className="card-body p-3">
                                                        <h6 className="card-title text-truncate mb-2" style={{ fontSize: '0.9rem' }}>
                                                            {product.product_name}
                                                        </h6>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span className="text-muted small">₹{product.product_purchase_rate}</span>
                                                            <div className="d-flex align-items-center">
                                                                <span className={`badge ${product.product_min_alert > product.total_remaining ? 'bg-danger' : 'bg-secondary'} me-1`}>
                                                                    {product.total_remaining}
                                                                </span>
                                                                {product.product_min_alert > product.total_remaining && (
                                                                    <i className="pi pi-exclamation-circle text-danger small"></i>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {addLoading && !listLoading && (
                                                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                backgroundColor: 'rgba(255, 255, 255, 0.85)',
                                                                zIndex: 2
                                                            }}
                                                        >
                                                            <div className="spinner-border text-primary" role="status"></div>
                                                        </div>
                                                    )}
                                                </div>
                                            </motion.div>
                                        ))
                                    ) : (
                                        <motion.div
                                            className="col-12"
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                        >
                                            <div className="text-center py-5">
                                                <i className="pi pi-search text-muted" style={{ fontSize: '2.5rem' }}></i>
                                                <h6 className="mt-3 text-muted">No products found</h6>
                                                <p className="small text-muted">Try changing your search or filters</p>
                                            </div>
                                        </motion.div>
                                    )}
                                </motion.div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <StockTransferPrint purchaseDetails={invoiceData} products={printProducts} user={user} isShow={false} />
        </div >
    );
};

export default StockTransfer;